import EA from 'helpers/init';
import { CountUp } from 'countup.js';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.customCounter = ($this) => {
    const start = $this;
    const targetNum = $this.dataset.num;
    let decimalPlacesAmount;

    function checkIfDecimal () {
        if (targetNum - Math.floor(targetNum) !== 0) {
            decimalPlacesAmount = 1;
        } else {
            decimalPlacesAmount = 0;
        };
    };

    checkIfDecimal();

    const options = {
        decimalPlaces: decimalPlacesAmount,
        separator: '.',
        decimal: ',',
        duration: 4,
    };

    const counter = new CountUp(start, targetNum, options);

    ScrollTrigger.create({
        trigger: $this,
        once: true,
        onEnter: () => {
            counter.start();
        }
    });
};